import styled from 'styled-components';
import { scale } from '../copied/Animations';

const TeaserTitle = styled.div`
  animation: ${scale} 0.3s ease forwards;
  transform: scale(0);
  transform-origin: ${props => (props.user ? 'bottom left' : 'bottom right')};
  display: block;
  font-size: 16px;
  text-transform: uppercase;
  font-weight: bold;
  margin: 0.2em auto;
`;

export default TeaserTitle;